export enum InvocationTools {
  WEB_SEARCH_TOOL = "externalSearchTool",
  VIDEO_SEARCH_TOOL = "videoSearchTool",
}